module.exports = __webpack_public_path__ + "static/media/scale4.d57f4672.png";